export const CDN_BASE_URL = 'https://d3cl3028wbfxoj.cloudfront.net';